import React, { useEffect, Suspense } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setWindowWidth } from '../../store/reducers/window/windowSlice';
import { closeMenuModal } from '../../store/reducers/modal/modalMenuSlice';

import Header from '../../components/Header';
import Main from '../../components/Main';
import Footer from '../../components/Footer';
import ModalMenu from '../../components/ModalMenu';
import Loading from '../../UI/Loading';
import Home from '../../pages/Home';
import Registration from '../../pages/Registration';
import Order from '../../pages/Order';
import Catalog from '../../pages/Catalog';
import Autoreg from '../../pages/Autoreg';
import CatalogDetail from '../../pages/CatalogDetail';
import Account from '../../pages/Account';
import Reviews from '../../pages/Reviews';
import Services from '../../pages/Services';
import Auth from '../../pages/Auth';
import Payment from '../../pages/Payment';

import './index.scss';
import { RootState } from '../../store';
import { CALENDAR } from '../../app_constants';
import {
  closeSearchModal,
  setTypeOpenSearchModal,
} from '../../store/reducers/modal/modalSearchSlice';

function AppRouter() {
  const dispatch = useDispatch();
  const location = useLocation();

  const isLogin = useSelector((state: RootState) => state.autorizationStatus.isLogin);
  const windowWidth = useSelector((state: RootState) => state.window.windowWidth);
  const typeOpenSearchModal = useSelector(
    (state: RootState) => state.modalSearch.typeOpenSearchModal,
  );

  useEffect(() => {
    if (location.pathname === '/') {
      if (windowWidth <= 959) {
        dispatch(closeSearchModal());
      } else if (typeOpenSearchModal !== CALENDAR) {
        dispatch(setTypeOpenSearchModal(CALENDAR));
      }
    } else if (typeOpenSearchModal === CALENDAR) {
      dispatch(closeSearchModal());
    }
  }, [windowWidth, location.pathname]);

  useEffect(() => {
    dispatch(closeMenuModal());
  }, [location.pathname]);

  useEffect(() => {
    function handleWindowResize() {
      dispatch(setWindowWidth(window.innerWidth));
    }

    dispatch(setWindowWidth(window.innerWidth));
    window.addEventListener('resize', handleWindowResize);

    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
    // eslint-disable-next-line
  }, [dispatch]);

  return (
    <>
      <Header />
      <Main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Registration />} />
          <Route path="/catalog/:cityName/" element={<Catalog />} />
          <Route path="/catalog/:cityName/:id/" element={<CatalogDetail />} />
          <Route path="/account/" element={<Account />} />
          <Route path="/reviews/" element={<Reviews />} />
          <Route path="/services/" element={<Services />} />
          <Route path="/autoreg/" element={<Autoreg />} />
          <Route
            path="/auth"
            element={
              <Suspense fallback={<div>Загрузка...</div>}>
                <Auth />
              </Suspense>
            }
          />
          <Route path="/payment" element={!isLogin ? <Loading /> : <Payment />} />
          <Route path="/order" element={!isLogin ? <Loading /> : <Order />} />
        </Routes>
      </Main>
      <Footer />
      <ModalMenu />
    </>
  );
}

export default AppRouter;
